import intl from "react-intl-universal";
import { useSelector } from "react-redux";

/* =====================
   TYPES
===================== */

type Props = {
  stapelId?: number;
  localStapelId?: string;
};

/* =====================
   COMPONENT
===================== */

const CountStapelSignDocsforUser = ({
  stapelId,
  localStapelId,
}: Props) => {
  const stapeluser =
    useSelector((state: any) => state.user.userhavetostapelsigndocs) ?? [];

  const stapel = stapeluser.find((s: any) => {
    // Backend-Stapel hat Priorität
    if (stapelId && s.id) {
      return s.id === stapelId;
    }

    // UI-Stapel (neu)
    if (localStapelId && s.localStapelId) {
      return s.localStapelId === localStapelId;
    }

    return false;
  });

  const count = stapel?.documentsSignModes?.length ?? 0;

  return <i>{count} {intl.get("COUNTSTAPELSIGNDOCSFORUSER_INFO")}</i>;
};

export default CountStapelSignDocsforUser;
